export const LOSS_TYPES = [
  {
    group: 'Weather & Catastrophe (CAT)',
    items: [
      'Windstorm / Hurricane',
      'Hail Damage',
      'Tornado',
      'Flood (FEMA / Rising Water)',
      'Storm Surge',
      'Lightning / Electrical Surge',
      'Freezing Temps / Frozen Pipes',
      'Sinkhole / Earth Movement',
    ],
  },
  {
    group: 'Water & Environmental',
    items: [
      'Water Escape / Sudden Plumbing Leak',
      'Sewer Backup / Drain Overflow',
      'Mold / Microbial Growth',
      'Asbestos / Environmental Contamination',
    ],
  },
  {
    group: 'Fire & Structural',
    items: [
      'Fire / Smoke Damage',
      'Explosion',
      'Collapse / Structural Failure',
      'Vehicle / Aircraft Impact',
    ],
  },
  {
    group: 'Human / Criminal Element',
    items: [
      'Vandalism / Malicious Mischief',
      'Theft / Burglary Damage',
      'Riot / Civil Commotion',
    ],
  },
  {
    group: 'Specialty & Specialty Commercial',
    items: [
      'Business Interruption / Loss of Use',
      'Builder Risk / Construction Defect',
      'Equipment Breakdown / Boiler & Machinery',
      'Crop / Agricultural Damage',
    ],
  },
  {
    group: 'Auto: Collision Losses',
    items: [
      'Auto: Collision - Multi-Vehicle Accident',
      'Auto: Collision - Single-Vehicle Crash / Rollover',
      'Auto: Collision - Fixed Object Impact (Pole, Guardrail, Wall)',
      'Auto: Collision - Pothole / Road Debris Impact',
    ],
  },
  {
    group: 'Auto: Comprehensive / Other Than Collision',
    items: [
      'Auto: Comp - Comprehensive Glass / Windshield Damage',
      'Auto: Comp - Vehicle Theft / Total Loss Stolen',
      'Auto: Comp - Vandalism / Keying / Smashed Glass',
      'Auto: Comp - Animal Impact',
      'Auto: Comp - Component Theft',
      'Auto: Comp - Flood / Water Submersion',
      'Auto: Comp - Hail / Severe Weather Damage',
      'Auto: Comp - Fire / Arson / Engine Explosion',
      'Auto: Comp - Falling Objects (Tree Branches, Debris)',
      'Auto: Comp - Chemical / Paint Overspray Damage',
    ],
  },
  {
    group: 'Specialty: Marine & Cargo',
    items: [
      'Specialty: Inland Marine / Cargo Loss',
      'Specialty: Marine / Hull Damage (Yacht & Watercraft)',
      'Specialty: Heavy Equipment / Commercial Fleet',
      'Specialty: Diminished Value Claims',
      'Specialty: Total Loss Valuation Disputes',
    ],
  },
];

export const ESTIMATING_SOFTWARE = [
  'Xactimate (Desktop / X1)',
  'Xactimate (Mobile / Cloud)',
  'Symbility (CoreLogic)',
  'CoreLogic Claims Connect',
  'RSMeans',
  'Hover / EagleView Integration',
  'Verisk / PropertyInSight',
  'Simsol',
  'Cubicasa',
  'Custom Spreadsheet / Line-Item Breakdown'
];

export const FLORIDA_COUNTIES = [
  'Alachua County',
  'Baker County',
  'Bay County',
  'Bradford County',
  'Brevard County',
  'Broward County',
  'Calhoun County',
  'Charlotte County',
  'Citrus County',
  'Clay County',
  'Collier County',
  'Columbia County',
  'DeSoto County',
  'Dixie County',
  'Duval County',
  'Escambia County',
  'Flagler County',
  'Franklin County',
  'Gadsden County',
  'Gilchrist County',
  'Glades County',
  'Gulf County',
  'Hamilton County',
  'Hardee County',
  'Hendry County',
  'Hernando County',
  'Highlands County',
  'Hillsborough County',
  'Holmes County',
  'Indian River County',
  'Jackson County',
  'Jefferson County',
  'Lafayette County',
  'Lake County',
  'Lee County',
  'Leon County',
  'Levy County',
  'Liberty County',
  'Madison County',
  'Manatee County',
  'Marion County',
  'Martin County',
  'Miami-Dade County',
  'Monroe County',
  'Nassau County',
  'Okaloosa County',
  'Okeechobee County',
  'Orange County',
  'Osceola County',
  'Palm Beach County',
  'Pasco County',
  'Pinellas County',
  'Polk County',
  'Putnam County',
  'Santa Rosa County',
  'Sarasota County',
  'Seminole County',
  'St. Johns County',
  'St. Lucie County',
  'Sumter County',
  'Suwannee County',
  'Taylor County',
  'Union County',
  'Volusia County',
  'Wakulla County',
  'Walton County',
  'Washington County',
  'Statewide / Travel Anywhere'
];